<template>
    <div class="calendar-date-indicator">{{ selectedMonth }}</div>
</template>

<script>
    export default {
        props: {
            selectedDate: {
                type: Object,
                required: true
            }
        },

        computed: {
            selectedMonth() {
                return this.selectedDate.format("MMMM YYYY");
            }
        }
    };
</script>

<style lang="scss" scoped>
    .calendar-date-indicator {
        font-family:satoshi, $poppins !important;
        font-size: 0.84em;
        font-weight: 600;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 12.5%;
    }
</style>